import { Dropdown, Menu, Flex, Button } from '@cognite/cogs.js';
import { Icon } from 'components/Icon';
import styled from 'styled-components/macro';
import { useFeatureFlag, FeatureFlags } from 'utils/feature-flags';
import {
  MenuItemDeleteStyles,
  MenuItemsStyles,
  OptionDescriptionStyles,
} from './styles';

type ConditionOptionsMenuProps = {
  showPropertyComparison: boolean;
  onAddCondition: VoidFunction;
  onDelete: VoidFunction;
  onTogglePropertyComparison: (propertyComparison: boolean) => void;
  propertyComparison: boolean;
};

export const ConditionOptionsMenu = ({
  showPropertyComparison,
  onAddCondition,
  onDelete,
  onTogglePropertyComparison,
  propertyComparison,
}: ConditionOptionsMenuProps) => {
  const enabledPropertyComparison = useFeatureFlag(
    FeatureFlags.enabledPropertyComparison
  );

  return (
    <Dropdown
      content={
        <StyledOptionsMenu>
          {enabledPropertyComparison && showPropertyComparison && (
            <>
              <Menu.Item
                onClick={() => onTogglePropertyComparison(!propertyComparison)}
                icon="GraphTree"
                iconPlacement="left"
                style={MenuItemsStyles}
              >
                <span style={{ marginRight: '1.2rem' }}>
                  Property comparison
                </span>
                {propertyComparison && <Icon type="Checkmark" />}
              </Menu.Item>
            </>
          )}
          <Menu.Item
            onClick={onDelete}
            icon="Delete"
            iconPlacement="left"
            style={MenuItemDeleteStyles}
          >
            <span>Delete condition</span>
          </Menu.Item>
          <Menu.Divider />
          <Menu.Item
            onClick={onAddCondition}
            icon="AddLarge"
            iconPlacement="left"
            style={MenuItemsStyles}
          >
            <StyledGrid>
              <Flex direction="column">
                <span>Add condition</span>
                <span
                  className="option_description"
                  style={OptionDescriptionStyles}
                >
                  Add a new condition below
                </span>
              </Flex>
            </StyledGrid>
          </Menu.Item>
        </StyledOptionsMenu>
      }
    >
      <Button
        aria-label="Open menu options for condition"
        type="ghost"
        icon="EllipsisVertical"
        style={{ verticalAlign: 'middle' }}
      />
    </Dropdown>
  );
};

const StyledOptionsMenu = styled(Menu)`
  min-width: 100px !important;
`;

const StyledGrid = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: auto 1fr;
  .cogs-icon {
    margin-bottom: 0.7rem;
  }
`;
